import request from '@/api/request';

/*
    Модель для работы с реперами внутри скважин
*/

const initialState = {
    /*
        wells - это наборы реперов, привязанных к конкретным скважинам.
    */
    wells: null,

    isLoading: false,
    error: null,

    /*
        Вспомогательное поле - значение для сохранения параметров запроса.
    */
    prevRequestParams: [],
    /*
        Вспомогательное поле - значение для сохранения предыдущей активной версии.
    */
    prevActiveVersionID: null,
};

export const wellsRappersModel = {
    name: 'wellsRappers',
    state: initialState,
    reducers: {
        setResponseData(state, payload) {
            const { packs } = payload;
            return { ...state, wells: packs, isLoading: false };
        },
        startRequest(state) {
            return { ...state, isLoading: true, error: null };
        },
        setError(state, error) {
            return { ...state, isLoading: false, error };
        },

        setPrevRequestParams(state, params) {
            return { ...state, prevRequestParams: params };
        },
        setPrevActiveVersionID(state, activeID) {
            return { ...state, prevActiveVersionID: activeID };
        },

        // отрефакторить когда будет api
        removeAllPackRappersData(state, packID) {
            if (state.wells) {
                const wells = Object.entries(state.wells).reduce((result, [wellId, value]) => {
                    const rappers = value.filter(x => x.packID !== packID);

                    result[wellId] = rappers;

                    return result;
                }, {});
                return { ...state, wells, isLoading: false };
            }

            return { ...state, isLoading: false };
        },
    },
    effects: {
        async getWellsRappers(_, rootState) {
            const { prevRequestParams, prevActiveVersionID } = rootState.wellsRappers;
            const { activeVersionID } = rootState.rappers;
            const { isGroup, activeTabletId, activeGroupIds } = rootState.tablets;

            let wellIDs = [];

            if (activeTabletId) {
                wellIDs.push(activeTabletId);
            }

            if (isGroup) {
                wellIDs = wellIDs.concat(activeGroupIds);
            }

            if (!activeVersionID) return;

            /*
                Повторный запрос происходит при условии, что предыдущие параметры НЕ совпадают с текущими и
                ID активной версии так же различаются
            */
            const isEqualParams = arrayEquals(prevRequestParams, wellIDs);
            const isEqualActiveID = prevActiveVersionID === activeVersionID;

            if (isEqualParams && isEqualActiveID) return;

            this.setPrevRequestParams(wellIDs);
            this.setPrevActiveVersionID(activeVersionID);

            this.startRequest();

            /*
                TODO:
                
                В качестве тела запроса здесь будут использоваться
                * id скважин, открытых на момент запроса
                * versionId - id активной версии

                body: {
                    wellId: [wellID, wellID, ..., wellID],
                    versionId: number
                }
            */
            try {
                /*
                    Fake request (for test) -> NODE server

                    const response = await fetch('/api/version-well-packs', {
                        method: 'POST',
                        body: JSON.stringify({
                            wellId: wellIDs,
                            versionId: activeVersionID
                        }),
                    });
                */

                const response = await request.post(`logging/version-well-packs/`, {
                    body: JSON.stringify({
                        wellId: wellIDs,
                        versionId: activeVersionID,
                    }),
                });

                const result = await response.json();
                this.setResponseData(result);
            } catch (error) {
                this.setError(error);
            }
        },

        async removeAllPackRappers(payload) {
            this.startRequest();

            this.removeAllPackRappersData(payload.packID);
        },
    },
};

function arrayEquals(a, b) {
    return a.length === b.length && a.every((val, index) => val === b[index]);
}
